import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const Fellowship = () => {
  const [collapseBtn, setCollapseBtn] = useState(true);
  const [fellowships, setFellowships] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    institute: "",
    duration: "",
    seats: "",
    admission: "",
  });

  const [loading, setLoading] = useState(false);

  // PROFESSIONAL ALERT
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  // DELETE CONFIRM MODAL
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // EDIT STATE
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    institute: "",
    duration: "",
    seats: "",
    admission: "",
  });

  // SHOW ALERT
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH FELLOWSHIPS
  const fetchFellowships = async () => {
    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/fellowships");
      const data = await res.json();
      setFellowships(data);
    } catch (err) {
      console.log("FETCH FELLOWSHIPS ERROR:", err);
      showAlert("danger", "Unable to fetch fellowships.");
    }
  };

  useEffect(() => {
    fetchFellowships();
  }, []);

  // FORM CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ADD FELLOWSHIP
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/fellowships", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Fellowship added successfully.");
        setFormData({
          title: "",
          institute: "",
          duration: "",
          seats: "",
          admission: "",
        });
        fetchFellowships();
      } else {
        showAlert("danger", result.message || "Failed to add fellowship.");
      }
    } catch (err) {
      console.log("FELLOWSHIP SUBMIT ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  // DELETE FELLOWSHIP
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteFellowship = async () => {
    try {
      const res = await fetch(`https://admin.vascularirdoctors.com/backend/fellowships/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Fellowship deleted successfully.");
        fetchFellowships();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);
      showAlert("danger", "Unable to delete fellowship.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  // OPEN EDIT
  const openEditModal = (item) => {
    setEditId(item.id);
    setEditData({
      title: item.title || "",
      institute: item.institute || "",
      duration: item.duration || "",
      seats: item.seats || "",
      admission: item.admission || "",
    });
    setShowModal(true);
  };

  // EDIT INPUT CHANGE
  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  // UPDATE FELLOWSHIP
  const updateFellowship = async () => {
    try {
      const res = await fetch(`https://admin.vascularirdoctors.com/backend/fellowships/${editId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editData),
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Fellowship updated successfully.");
        setShowModal(false);
        fetchFellowships();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE ERROR:", err);
      showAlert("danger", "Unable to update fellowship.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
                
                <li className="breadcrumb-item active" aria-current="page">
                  Fellowship Programs
                </li>
              </ol>
            </div>

            {/* TOP RIGHT CLOSE BUTTON */}
            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {/* ALERT */}
        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type} className="shadow-sm rounded-3">
              {alert.text}
            </Alert>
          </div>
        )}

        {/* ADD FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fas fa-graduation-cap me-1"></i>Add Fellowship
              </div>
              <div className="tools">
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => setCollapseBtn(!collapseBtn)}
                >
                  <i
                    className={`fas ${
                      collapseBtn ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </button>
              </div>
            </div>

            <Collapse in={collapseBtn}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <form onSubmit={submitHandler}>
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Fellowship Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="Enter fellowship title"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Institute</label>
                          <input
                            type="text"
                            className="form-control"
                            name="institute"
                            value={formData.institute}
                            onChange={handleChange}
                            placeholder="Enter institute name"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Duration</label>
                          <input
                            type="text"
                            className="form-control"
                            name="duration"
                            value={formData.duration}
                            onChange={handleChange}
                            placeholder="Example: 1 Year Fellowship"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Seats</label>
                          <input
                            type="text"
                            className="form-control"
                            name="seats"
                            value={formData.seats}
                            onChange={handleChange}
                            placeholder="Example: 1 Seat Per Year"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Admission</label>
                          <textarea
                            className="form-control"
                            rows="7"
                            name="admission"
                            value={formData.admission}
                            onChange={handleChange}
                            placeholder="Example: Interview / Entrance Exam"
                            required
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-xl-12 text-end">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Fellowship"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Collapse>
          </div>
        </div>

        {/* FELLOWSHIP LIST */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-list me-1"></i>Uploaded Fellowships
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Title</th>
                      <th>Institute</th>
                      <th>Duration</th>
                      <th>Seats</th>
                      <th>Admission</th>
                      <th style={{ width: "170px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fellowships.length > 0 ? (
                      fellowships.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.institute}</td>
                          <td>{item.duration}</td>
                          <td>{item.seats}</td>
                          <td>{item.admission}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => openEditModal(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => confirmDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No fellowships found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Fellowship</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label>Fellowship Title</label>
              <input
                type="text"
                className="form-control"
                name="title"
                value={editData.title}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Institute</label>
              <input
                type="text"
                className="form-control"
                name="institute"
                value={editData.institute}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Duration</label>
              <input
                type="text"
                className="form-control"
                name="duration"
                value={editData.duration}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Seats</label>
              <input
                type="text"
                className="form-control"
                name="seats"
                value={editData.seats}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Admission</label>
              <textarea
                className="form-control"
                rows="5"
                name="admission"
                value={editData.admission}
                onChange={handleEditChange}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateFellowship}>
            Update Fellowship
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE CONFIRM MODAL */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Fellowship</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this fellowship? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteFellowship}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Fellowship;